import { getISOWeek } from 'date-fns'

/**
 *
 * This function in related to the issue TKB01-92
 * We need to store the "has slots" information about each of the browsed weeks
 * Because when we switch back and forth through the calendar we need that info
 * To activate / deactivate the back button (we can't get this info from the backend)
 *
 * WARNING: Edge Case
 * This solution works fine but only if you browse the weeks and we can store the
 * slots status for each one… but when you land to the calendar from the
 * “UPDATE APPOINTMENT BUTTON” we don’t have anyinfo about the previous weeks yet
 * so we can't avoid the issue
 *
 * @param weeksSlotsHistory
 * weeksSlotsHistory it's the current list of the browsed weeks
 * @param weekFirstDay
 * weekFirstDay is the starting day of the week (it could be sunday or monday depending on the calendar)
 * @param slots
 * slots it's the promise that returns the slots for that week
 * @returns
 * it returns the updated list of the browsed weeks
 */
export const getWeeksSlotsHistory = (weeksSlotsHistory, weekFirstDay, slots) => {
  const weekNumber = getISOWeek(weekFirstDay)
  slots.then((response) => {
    // @ts-expect-error Property get does not exist on type 'DataTypeSorted'
    const hasSlots = response.get('branches').size > 0
    if (!weeksSlotsHistory.find((week) => week.weekNumber === weekNumber)) {
      weeksSlotsHistory.push({ weekNumber, hasSlots })
    } else {
      const weekIndex = weeksSlotsHistory.findIndex((week) => week.weekNumber === weekNumber)
      weeksSlotsHistory[weekIndex] = { weekNumber, hasSlots }
    }
  })
  return weeksSlotsHistory
  //
}
